import {
  Staff,
  CreateStaffData,
  UpdateStaffData,
  StaffFilters,
} from "@lemmonhq/types";
import { getAPIClient } from "../helpers";

export const staffAPI = {
  getStaff: async (filters?: StaffFilters): Promise<Staff[]> => {
    const hc = getAPIClient();

    const query: Record<string, unknown> = {};

    if (filters?.search) {
      query.search = filters.search;
    }
    if (filters?.staff_type) {
      query.staff_type = filters.staff_type;
    }
    if (typeof filters?.limit === "number") {
      query.limit = String(filters.limit);
    }
    if (typeof filters?.offset === "number") {
      query.offset = String(filters.offset);
    }

    const resp = await hc.api.v2.staff.$get({
      query: query as Record<string, string | string[]>,
    });

    if (resp.ok) {
      const json: any = await resp.json();
      const data: Staff[] = Array.isArray(json) ? json : [];
      return data;
    }
    throw new Error("Failed to fetch staff");
  },

  getStaffMember: async (staffId: string): Promise<Staff> => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.staff[":id"].$get({
      param: { id: staffId },
    });

    if (resp.ok) {
      return (await resp.json()) as Staff;
    }
    throw new Error("Failed to fetch staff member");
  },

  createStaff: async (data: CreateStaffData): Promise<Staff> => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.staff.$post({
      json: data as any,
    });

    if (resp.ok) {
      return (await resp.json()) as Staff;
    }
    throw new Error("Failed to create staff member");
  },

  updateStaff: async (
    staffId: string,
    data: UpdateStaffData,
  ): Promise<Staff> => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.staff[":id"].$patch({
      param: { id: staffId },
      json: data as any,
    });

    if (resp.ok) {
      return (await resp.json()) as Staff;
    }
    throw new Error("Failed to update staff member");
  },

  deleteStaff: async (staffId: string): Promise<{ success: boolean }> => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.staff[":id"].$delete({
      param: { id: staffId },
    });

    if (resp.ok) {
      return (await resp.json()) as { success: boolean };
    }
    throw new Error("Failed to delete staff member");
  },
};
